export let PaymentMethodType;
(function (PaymentMethodType) {
  PaymentMethodType["UNKNWON"] = "unknown";
  PaymentMethodType["CARD"] = "card";
})(PaymentMethodType || (PaymentMethodType = {}));